<template>
    <div>
        <modal :show.sync="addItem" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar ítem</h6>
                <div class="form-group">
                    <label>Ítem *</label>
                    <fg-input   type="text"
                                name="ítem"
                                placeholder="ítem"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('ítem')"
                                v-model="itemName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio de compra</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="precio de compra" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="itemPurchasePrice"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Precio de venta</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.sales" :error="getError('precio de venta')" separator="." class="form-control" v-model="itemSalePrice"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>%</label>
                    <fg-input   type="number"
                                name="%"
                                disabled
                                placeholder="%"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :value="item_percent_computed"
                                :error="getError('%')"
                                v-model="itemPercent">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddItem()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addItemToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Editar línea de producto</h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Nombre *</label>
                    <fg-input   type="text"
                                name="nombre"
                                placeholder="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.product_name"
                                :error="getError('nombre')"
                                v-model="productLineName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Promedio de compra</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="promedio de compra" v-validate="modelValidations.sales" :error="getError('promedio de compra')" separator="." class="form-control" v-model="productLinePurchaseCost"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Frecuencia mes</label>
                    <fg-input   type="number"
                                name="frecuencia mes"
                                placeholder="frecuencia de compra al mes"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('frecuencia mes')"
                                v-model="productLineMonthly">
                    </fg-input>
                </div>
                <!-- <div class="form-group">
                    <label>Total</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="total" disabled v-validate="modelValidations.sales" :error="getError('total')" separator="." class="form-control" v-model="productLineTotal"></vue-numeric>
                </div> -->
                <div v-if="productLineTotal != 0" class="alert alert-warning mt-2">
                    <span>Total: {{ setFormat(productLineTotal)}}</span>
                </div>
                <!-- <collapse v-for="item in items" :key="item.itemName">
                    <collapse-item :title="item.itemName+' - '+ item.itemPercent + '%'" :name="item.itemName">
                    <div>
                        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                    </div>
                    </collapse-item>
                </collapse> -->
                <!-- <div v-if="items.length < 5">
                    <p-button 
                        @click="addItemMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar ítem
                    </p-button>
                </div>
                <div v-if="items.length > 1">
                    <p-button 
                        @click="removeItem()"
                        type="default" >
                        <i class="mr-2 fa fa-minus"></i>Quitar ítem
                    </p-button>
                </div> -->
                <div v-if=" (salesMonthlyAverage > 0)" class="alert alert-warning mt-2">
                    <span>Promedio ventas mensual: {{ salesMonthlyAverage}}%</span>
                </div>
                <div v-if=" (salesMonthlyAverage > 0)" class="alert alert-warning mt-2">
                    <span>Costo mensual de la línea: {{ setFormat(costsMonthlyLine)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div class="text-right">
            <p-button v-if="productLineTotal != 0" @click="saveCosts()" type="warning">Siguiente</p-button>
            <p-button @click="toGeneralCosts()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            form: {
                average_selection: '',
            },
            itemName: '',
            itemPurchasePrice: '',
            itemSalePrice: '',
            itemPercent: '',
            productLineName: '',
            productLinePurchaseCost: '',
            productLinePurchaseCostFormat: '',
            productLineMonthly: '',
            productLineTotal: '',
            productLineTotalFormat: '',
            addItem: false,
            items: [
                
            ],
            modelValidations: {
                sales: {
                    required: true
                },
                item_name: {
                    required: false,
                    max: 32
                },
                product_name: {
                    required: true,
                    max: 32
                },
                average_selection: {
                    required: true
                }
            },
        }
        },
        watch: {
            productLinePurchaseCost: function (val) {
                if (val != 0) {
                    if (this.productLineMonthly != 0) {
                        this.productLineTotal = parseFloat(val) * parseFloat(this.productLineMonthly);
                        this.productLineTotalFormat = this.setFormat(this.productLineTotal);
                        this.productLinePurchaseCostFormat = this.setFormat(val);
                    }
                }
                else {
                    this.productLineTotal = 0;
                    this.productLineTotalFormat = 0;
                    this.productLinePurchaseCostFormat = 0;

                }
            },
            productLineMonthly: function (val) {
                if (val != 0) {
                    if (this.productLinePurchaseCost != 0) {
                        this.productLineTotal = parseFloat(val) * parseFloat(this.productLinePurchaseCost)
                    }
                }
                else {
                    this.productLineTotal = 0;
                }
            }
            
        },
        computed: {
            costsMonthlyLine () {
                return 5000;
            },
            salesMonthlyAverage () {
                var avg = 0;
                var sum = 0;
                for (var i=0;i<this.items.length;i++) {
                    sum = sum + this.items[i].itemPercent;
                }
                avg = sum / this.items.length;
                return Math.round(avg);
            },
            validateGeneralCosts () {
                if(this.productLineName && this.productLinePurchaseCost != 0 && this.productLineMonthly && (this.items.length >= 3 && this.items.length <= 5)) {
                    return true
                }
                else {
                    return false
                }
            },
            item_percent_computed () {
                var percent = 0;
                if (this.itemPurchasePrice != 0 && this.itemSalePrice != 0) {
                    percent =  Math.round((this.itemPurchasePrice * 100) / this.itemSalePrice);
                }
                this.itemPercent = percent;
                return percent;
            },
        },
        methods: {
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            addItemToList () {
                if (this.itemName == '' || this.itemPercent == 0) {
                    this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
                }
                else {
                    this.items.push({
                        itemName: this.itemName,
                        itemPurchasePrice: this.itemPurchasePrice,
                        itemSalePrice: this.itemSalePrice,
                        itemPercent: this.itemPercent
                    })
                    this.resetItem();
                    this.addItem = false;
                    this.showNotificationSuccess('Producto agregado correctamente');
                }
            },
            removeItem () {
                this.items.splice(this.items.length-1,1);
            },
            resetItem () {
                this.itemName= '',
                this.itemPurchasePrice= '',
                this.itemSalePrice= '',
                this.itemPercent= ''
            },
            addItemMethod () {
                this.addItem = true;
            },
            cancelAddItem () {
                this.addItem = false;
                this.resetItem();
            },
            dailySelectValidation () {
                if (this.checkboxes.filter(day => day.value == true).length) {
                    return false
                }
                else {
                    return true
                }
            },
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 2, thousand: ".", decimal: "," });
            },
            /*** 
             * Función que permite visualizar los errores en cada campo del input
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            validateSwitch () {
                if(this.switches.daily || this.switches.weekly || this.switches.monthly || this.switches.product || this.switches.average) {
                    return true
                }
                else {
                    return false
                }
            },
            toGeneralCosts () {
                this.$router.push('/asessments/new_asessment/customer/costs/business/general');
            },
            saveCosts () {
                this.$store.dispatch('editCostsProductLine', this.$data).then(()=>{
                    this.$store.dispatch('setCostsDataPopulate', true).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/costs/business/general');
                    });
                });
            }
        },
        mounted () {
            console.log()
            if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].editProduct) {
                this.productLineName = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductLine[this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].editProductIndex].productLineName;
                this.productLinePurchaseCost = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductLine[this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].editProductIndex].productLinePurchaseCost;
                this.productLinePurchaseCostFormat = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductLine[this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].editProductIndex].productLinePurchaseCostFormat;
                this.productLineMonthly = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductLine[this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].editProductIndex].productLineMonthly;
                this.productLineTotal = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductLine[this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].editProductIndex].productLineTotal;
                this.productLineTotalFormat = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductLine[this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].editProductIndex].productLineTotalFormat;
            }
        }
    }
</script>
<style>
</style>
